import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getInternalAuditEntityFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t('internalAudits.fields.Title'),
      allowAsConditionSource: true,
    },
    Description: {
      fieldId: 'Description',
      formLabel: t('internalAudits.fields.Description'),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    BusinessArea: {
      fieldId: 'BusinessArea',
      formLabel: t('internalAudits.fields.BusinessArea'),
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t(`fields.Owner`),
      columnHeader: t(`columns.owners`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t(`fields.Contributor`),
      columnHeader: t(`columns.contributors`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Viewers: {
      fieldId: 'Viewers',
      formLabel: t(`fields.Viewer`),
      columnHeader: t(`columns.viewers`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
    },
    tags: {
      fieldId: 'tags',
      formLabel: t(`fields.Tags`),
      columnHeader: t(`columns.tags`),
      displayType: {
        displayType: 'tags',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    departments: {
      fieldId: 'departments',
      formLabel: t(`fields.Departments`),
      columnHeader: t(`columns.departments`),
      displayType: {
        displayType: 'departments',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
